import unitData from './unit_data.data';
import { UnitConverter } from '@/mixins/unit-converter.mixin'
import API from '@/api'

export default {
	namespaced: true,
	state: {
		unit_types: ['Metric', 'US'],
		target: 'Metric',
		units: unitData
	},
	mutations: {

	},
	actions: {
		setTarget: ({state, dispatch, commit}, type) => {
			const t = type.toLowerCase();
			if (state.unit_types.indexOf(type) == -1) {
				return false;
			}

			return API.user.saveUnit({unit: t}).then(res => {
				state.target = type;
			});
		}
	},
	getters: {
		metricUnit: (state) => (unit) => {
			var unitData = state.units.find(item => item.key === unit);
			return unitData ? unitData : false;
		},
		usUnit: (state) => (unit) => {
			var unitData = state.units.find(item => item.us.label === unit);
			return unitData ? unitData : false;
		},
		unitByUs: (state) => (unit, us) => {
			var unitData = state.units.find(item => item.us.label === us && item.key === unit);
			return unitData ? unitData : false;
		},

		toMetric: (state, getters) => (unitData, val) => {
			var resVal = val * unitData[state.target.toLowerCase()].factor;
			return UnitConverter.methods.round(resVal);
		},
		fromMetric: (state, getters) => (unitData, val) => {
			var resVal = val / unitData[state.target.toLowerCase()].factor;

			return resVal;
		},

		convert: (state, getters) => (unit, val, us = false) => {
			
			if (unit == 'C')
				return getters['tConvert'](+val).toFixed();
				// return +val;
			var unitData;
			if (!us) {
				unitData = getters['metricUnit'](unit);
			} else {
				unitData = getters['unitByUs'](unit, us);
			}
			return unitData !== false ? UnitConverter.methods.round(parseFloat(getters['toMetric'](unitData, val))) : UnitConverter.methods.round(parseFloat(val));
		},
		unConvert: (state, getters) => (unit, val, us = false) => {
			if (unit == 'C')
				return getters['tUnConvert'](val);

			var unitData;
			if (!us) {
				unitData = getters['metricUnit'](unit);
			} else {
				unitData = getters['unitByUs'](unit, us);
			}

			return unitData !== false ? getters['fromMetric'](unitData, val) : val;
		},

		getLabel: (state, getters) => (unit, us = false) => {
			var unitData;
			if (!us) {
				unitData = getters['metricUnit'](unit);
			} else {
				unitData = getters['unitByUs'](unit, us);
			}

			return unitData !== false ? unitData[state.target.toLowerCase()].label : unit;
		},

		tConvert: (state) => (val) => {
			if (state.target.toLowerCase() == 'metric')
				return val;

			val = val == null ? 0 : val;

			return (val * 9/5) + 32;
		},
		tUnConvert: (state) => (val) => {
			if (state.target.toLowerCase() == 'metric')
				return val;

			val = val == null ? 0 : val;

			return (val - 32) * 5/9;
		},

		target: (state) => {
			return state.target;
		},
		types: (state) => {
			return state.unit_types;
		},
		isUnit: (state, getters) => (unit) => {
			var unitData = getters['metricUnit'](unit);
			return !unitData ? false : true;
		}
	}
};
